// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: false,
		// paginationType: boostPFSConfig.custom.pagination_type.indexOf("load_more") != -1 ? "load_more" :
		// 				(boostPFSConfig.custom.pagination_type == 'infinite_scroll' ? 'infinite' : 'default'),
        // filterTreeMobileStyle: 'style-expand'
        requestInstantly: true,
        showLimitList: '25,50',
        limit: 25, 
	},
    selector: {		
		trackingQuickView: '.quick_shop'				
	}
};

// Declare Templates
var boostPFSTemplate = {
	// Grid Template
    'productGridItemHtml':  '<tr>' +
                              '<td><a href="{{itemUrl}}">{{itemImages}}</a></td>' +
                              '<td><a href="{{itemUrl}}">{{itemPartNumber}}</a></td>' +
                              '<td>{{itemUnit}}</td>' +
                              '<td>{{itemThreadSize}}</td>' +
                              '<td>{{itemMaterial}}</td>' +
                              '<td>{{itemFinish}}</td>' +
                              '<td>{{itemSheetMin}}</td>' +
                              '<td>{{itemLength}}</td>' +
                              '<td>{{itemPackSize}}</td>' +
                              '<td>{{itemPrice}}</td>' +
                              '<td class="boost-pfs-cart-btn">{{itemCart}}</td>' +
                            '</tr>',
    'productGridItemMobileHtml':  '<tr>' +
                                    '<td><a href="{{itemUrl}}">{{itemImages}}</a></td>' +
                                    '<td class="boost-pfs-info">' +
                                        '<span>{{itemPartNumber}}</span>' +
                                        '<span>{{itemUnit}}</span>' +
                                        '<span>{{itemThreadSize}}</span>' +
                                        '<span>{{itemMaterial}}</span>' +
                                        '<span>{{itemFinish}}</span>' +
                                        '<span>{{itemSheetMin}}</span>' +
                                        '<span>{{itemLength}}</span>' +
                                        '<span>{{itemPackSize}}</span>' +
                                        '<span>{{itemPrice}}</span>' +
                                    '</td>' +
                                    '<td class="boost-pfs-cart-btn">{{itemCart}}</td>' +
                                  '</tr>',
	
	'itemHoverHtml' : '<div class="thumbnail-overlay__container">' +
						    '<a class="hidden-product-link" href="{{itemUrl}}">{{itemTitle}}</a>' +
							'{{itemProductInfoHover}}' +
							'{{itemQuickShop}}' +
						    '{{itemReviewsHover}}' +
						'</div>',

	'itemProductInfoHtml': '<div class="product-thumbnail">' +
								'{{itemVendor}}' +
								'<a href="{{itemUrl}}" class="product-thumbnail__title">{{itemTitle}}</a>' +
								'{{itemComingSoon}}' +
                                '{{itemPrice}}' +
                                '<br/>'+
                                '<div class="custom-product-sku" style="margin-top: 1em;">'+
                                '<span style="color: grey;">SKU: '+
                                '{{itemSku}}'+
                                '</span>'+
                                '</div>'+
							'</div>',
	
	// Pagination Template
	'previousActiveHtml': '<a href="{{itemUrl}}" class="pagination-previous">'+ boostPFSConfig.label.previous +'</a>',
	'nextActiveHtml': '<a href="{{itemUrl}}" class="pagination-next">'+ boostPFSConfig.label.next +'</a>',
	'pageItemHtml': '<li><a class="pagination-link" href="{{itemUrl}}">{{itemTitle}}</a></li>',
	'pageItemSelectedHtml': '<li><a class="pagination-link is-current">{{itemTitle}}</a></li>',
	'pageItemRemainHtml': '<li><a class="pagination-ellipsis">…</a></li>',
	'paginateHtml': '<nav class="pagination paginate--both" role="navigation" aria-label="pagination">{{previous}}<ul class="pagination-list">{{pageItems}}</ul>{{next}}</nav>',

	// Sorting Template
	'sortingHtml': '<select aria-label="Sort by" class="sort_by">{{sortingItems}}</select>',
    'showLimitHtml':'<label class="pfs-limit-custom"> Showing 1-  </label><select class="boost-pfs-filter-filter-dropdown-custom">{{showLimitItems}} </select><span>of </span><label class="pfs-total-product"> '+boostPFSConfig.general.collection_count+'</label>'
};

(function () { 
	BoostPFS.inject(this);

    // Build Product Grid Item
    ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {
        if (!data) data = this.data;
        if (!index) index = this.index;
        if (!totalProduct) totalProduct = this.totalProduct;
       console.log(data)
        // Get Template
        var itemHtml = Utils.isMobile() ? boostPFSTemplate.productGridItemMobileHtml : boostPFSTemplate.productGridItemHtml;
    
        // Part number
        var itemPartNumber = data.variants[0]['sku'];
        itemHtml = itemHtml.replace(/{{itemPartNumber}}/g, itemPartNumber);
    
        // Unit
        var itemUnit = '';
        if (Utils.getProductMetafield(data, 'Fasteners', 'Thread_Type') !== null) {
            var metaData = Utils.getProductMetafield(data, 'Fasteners', 'Thread_Type');
            if (metaData.indexOf(':') !== -1) {
                metaData = metaData.split(':');
                metaData = metaData[metaData.length - 1];
            }
            itemUnit += metaData;
        }
        itemHtml = itemHtml.replace(/{{itemUnit}}/g, itemUnit);
    
        // Thread Size
        var itemThreadSize = '';
        if (Utils.getProductMetafield(data, 'Fasteners', 'Thread_Size') !== null) {
            var metaData = Utils.getProductMetafield(data, 'Fasteners', 'Thread_Size');
            if (metaData.indexOf(':') !== -1) {
                metaData = metaData.split(':');
                metaData = metaData[metaData.length - 1];
            }
            itemThreadSize += metaData;
        }
        itemHtml = itemHtml.replace(/{{itemThreadSize}}/g, itemThreadSize);
    
        // Material
        var itemMaterial = '';
        var foundMaterialTag = data.tags.filter(function(e) {
            return e.indexOf('Filter Material-') !== -1;
        })
        if (typeof foundMaterialTag[0] !== 'undefined') {
            for (var i = 0; i < foundMaterialTag.length; i++) {
                var material = foundMaterialTag[i];
                material = material.split('Filter Material-');
                material = material[material.length - 1];
                itemMaterial += material;
                if (i < foundMaterialTag.length - 1) {
                    itemMaterial += ', ';
                }
            }
        }
        itemHtml = itemHtml.replace(/{{itemMaterial}}/g, itemMaterial);
    
        // Finish
        var itemFinish = '';
        var foundFinishTag = data.tags.filter(function(e) {
            return e.indexOf('Filter Finish-') !== -1;
        })
        if (typeof foundFinishTag[0] !== 'undefined') {
            for (var i = 0; i < foundFinishTag.length; i++) {
                var finishEle = foundFinishTag[i];
                finishEle = finishEle.split('Filter Finish-');
                finishEle = finishEle[finishEle.length - 1];
                itemFinish += finishEle;
                if (i < foundFinishTag.length - 1) {
                    itemFinish += ', ';
                }
            }
        }
        itemHtml = itemHtml.replace(/{{itemFinish}}/g, itemFinish);
    
        // Sheet min
        var itemSheetMin = '';
        if (Utils.getProductMetafield(data, 'Fasteners', 'Sheet_Metal_Thickness') !== null) {
            var metaData = Utils.getProductMetafield(data, 'Fasteners', 'Sheet_Metal_Thickness');
            if (metaData.indexOf(':') !== -1) {
                metaData = metaData.split(':');
                metaData = metaData[metaData.length - 1];
            }
            itemSheetMin += metaData;
        }
        itemHtml = itemHtml.replace(/{{itemSheetMin}}/g, itemSheetMin);
    
        // Length
        var itemLength = '';
        if (Utils.getProductMetafield(data, 'Fasteners', 'Dim_L') !== null) {
            var metaData = Utils.getProductMetafield(data, 'Fasteners', 'Dim_L');
            if (metaData.indexOf(':') !== -1) {
                metaData = metaData.split(':');
                metaData = metaData[metaData.length - 1];
            }
            itemLength += metaData;
        }
        itemHtml = itemHtml.replace(/{{itemLength}}/g, itemLength);
    
        // Pack Size
        var itemPackSize = '';
        if (Utils.getProductMetafield(data, 'global', 'Item_Multiple') !== null) {
            var metaData = Utils.getProductMetafield(data, 'global', 'Item_Multiple');
            if (metaData.indexOf(':') !== -1) {
                metaData = metaData.split(':');
                metaData = metaData[metaData.length - 1];
            }
            itemPackSize += metaData;
        }
        itemHtml = itemHtml.replace(/{{itemPackSize}}/g, itemPackSize);
    
        // Price
        var priceHtml = Utils.formatMoney(data.variants[0]['price']);
        if (parseFloat(data.variants[0]['price']) == 999.99 || parseFloat(data.variants[0]['price']) == 99999.00 || parseFloat(data.variants[0]['price']) == 49999.50) {
            priceHtml = 'Quote only';
        }
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, priceHtml);
    
        // Cart
        var itemCart = '';
        // if (data.available) {
        //     itemCart += '<input type="number" min="1" />';
        //     itemCart += '<span class="icon header__icon cart-btn" data-icon="cart" data-variant-id="' + data.variants[0]['id'] + '" data-url="{{itemUrl}}">';
        //     itemCart += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="cart"><circle cx="45.55" cy="88.68" r="6.49"></circle><circle cx="74.82" cy="88.68" r="6.49"></circle><path d="M96.79,22.81a8.45,8.45,0,0,0-8.25-10.3H27.1L25.54,4.84H3v8H19L32,76.75H91.12v-8H38.51l-1.36-6.69H88Z"></path></g></svg>';
        //     itemCart += '</span>';
        // }
        itemHtml = itemHtml.replace(/{{itemCart}}/g, itemCart);
    
        // Add class
        var itemDesktopWidthClass = 'one-third';
        switch (boostPFSConfig.custom.products_per_row) {
            case 1:
                itemDesktopWidthClass = 'one-whole';
                break;
            case 2:
                itemDesktopWidthClass = 'one-half';
                break;
            case 3:
                itemDesktopWidthClass = 'one-third';
                break;
            case 4:
                itemDesktopWidthClass = 'one-fourth';
                break;
            case 5:
                itemDesktopWidthClass = 'one-fifth';
                break;
            case 6:
                itemDesktopWidthClass = 'one-sixth';
                break;
            case 7:
                itemDesktopWidthClass = 'one-seventh';
                break;
            case 8:
                itemDesktopWidthClass = 'one-eighth';
                break;
        }
        itemHtml = itemHtml.replace(/{{itemDesktopWidthClass}}/g, itemDesktopWidthClass);
        itemHtml = itemHtml.replace(/{{itemMobileWidthClass}}/g, boostPFSConfig.custom.mobile_products_per_row == 1 ? 'small-down--one-whole' : 'small-down--one-half');
        itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, boostPFSConfig.custom.enable_quickshop ? 'quick-shop--true quick-shop--closed product-{{itemId}} js-product_section' : '');
        itemHtml = itemHtml.replace(/{{itemStickersClass}}/g, boostPFSConfig.custom.stickers_enabled ? 'has-thumbnail-sticker' : '');
        itemHtml = itemHtml.replace(/{{itemHoverClass}}/g, boostPFSConfig.custom.thumbnail_hover_enabled.toString());
        itemHtml = itemHtml.replace(/{{itemSwapImageClass}}/g, boostPFSConfig.custom.show_secondary_image && data.images_info.length > 1 ? 'swap--true' : '');
        itemHtml = itemHtml.replace(/{{itemHoverImage}}/g, boostPFSConfig.custom.show_secondary_image && data.images_info.length > 1 ? 'has-secondary-image-swap' : '');
        itemHtml = itemHtml.replace(/{{itemTextAlignClass}}/g, boostPFSConfig.custom.thumbnail_text_alignment);
    
        // Add stickers
        var itemStickers = buildStickers(data);
        itemHtml = itemHtml.replace(/{{itemStickers}}/g, itemStickers);
    
        // Add images
        var itemImages = buildImages(data);
        itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);
    
        // Add main attribute (Always put at the end of this function)
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
        itemHtml = itemHtml.replace(/{{totalProduct}}/g, 1234);
        return itemHtml;
    };
    
    function buildStickers(data) {
        var html = '';
        var stickers = [];
        if (boostPFSConfig.custom.stickers_enabled) {
            var collections = data.collections.map(x => x.handle);
            var stickerCollections = ['best-seller', 'coming-soon', 'new', 'pre-order', 'staff-pick'];
            for (var i = 0; i < stickerCollections.length; i++) {
                var stickerCollection = stickerCollections[i];
                if (collections.indexOf(stickerCollection) != -1) {
                    var stickerText = boostPFSConfig.label[stickerCollection.replace('-', '_')];
                    var sticker = '<div class="' + stickerCollection + '-sticker thumbnail-sticker sticker-' + i + '"><span class="sticker-text">' + stickerText + '</span></div>';
                    stickers.push(sticker);
                }
            }
    
            var onSale = data.available && data.price_min < data.compare_at_price_max;
            if (onSale) {
                var sticker = '<div class="sale-sticker thumbnail-sticker"><span class="sticker-text">' + boostPFSConfig.label.sale + '</span></div>';
                stickers.push(sticker);
            }
    
            if (stickers.length > 0) {
                html = '<div class="sticker-holder sticker-shape-' + boostPFSConfig.custom.sticker_shape + ' sticker-position-' + boostPFSConfig.custom.sticker_position + '">' +
                    '<div class="sticker-holder__content sticker-holder__content--">' +
                    stickers.join('') +
                    '</div>' +
                    '</div>';
            }
        }
        return html;
    }
    
    function buildImages(data) {
        var html = '';
        var images = data.images_info;
        if (!images || images.length == 0) {
            images.push({
                src: boostPFSAppConfig.general.no_image_url,
                width: 480,
                height: 480
            })
        }
    
        html += buildImageElement(images[0]);
    
        if (boostPFSConfig.custom.show_secondary_image && images.length > 1) {
            html += buildImageElement(images[1], 'lazypreload secondary swap--visible');
        }
    
        return html;
    }
    
    function buildImageElement(image, additionalClass) {
        var additionalClass = (typeof additionalClass !== 'undefined') ? additionalClass : '';
        var html = '';
        var heightStyle = '';
        var widthStyle = '';
        var aspectRatio = image.width / image.height;
        if (boostPFSConfig.custom.align_height) {
            heightStyle += 'max-height: ' + boostPFSConfig.custom.collection_height + 'px;';
            widthStyle += 'width: ' + (aspectRatio * boostPFSConfig.custom.collection_height) + 'px; max-width: ' + image.width + 'px;';
        }
    
        var backgroundColor = boostPFSConfig.custom.image_loading_style == 'color' ? 'background: url(' + Utils.optimizeImage(image.src, '1x') + '); ' : '';
        var lowQualityImage = boostPFSConfig.custom.image_loading_style == 'blur-up' ? Utils.optimizeImage(image.src, '50x') : '';
    
        html += '<div class="image-element__wrap" style="' + backgroundColor + heightStyle + widthStyle + '">' +
            '<img alt="{{itemTitle}}"' +
            ' class="lazyload transition--' + boostPFSConfig.custom.image_loading_style + ' ' + additionalClass + '"' +
            (lowQualityImage && lowQualityImage !== '' ?
                ' src="' + lowQualityImage + '"' : '') +
            ' data-src="' + Utils.optimizeImage(image.src, '1600x') + '"' +
            ' data-sizes="auto"' +
            ' data-aspectratio="' + aspectRatio + '"' +
            ' data-srcset="' + bgset(image) + '"' +
            ' srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="' +
            ' height="' + image.height + '"' +
            ' width="' + image.width + '"' +
            ' style="' + heightStyle + '"' +
            '/>' +
            '</div>';
        return html;
    }
    
    function buildHover(data) {
        var html = '';
        if (boostPFSConfig.custom.enable_quickshop || boostPFSConfig.custom.thumbnail_hover_enabled) {
            html = boostPFSTemplate.itemHoverHtml;
            if (boostPFSConfig.custom.thumbnail_hover_enabled) {
                var itemProductInfoHover = '<div class="quick-shop__info">' +
                    '<div class="thumbnail-overlay">' +
                    '<div class="info text-align-center">' +
                    '{{itemProductInfo}}' +
                    '</div>' +
                    '</div>' +
                    '</div>';
                html = html.replace(/{{itemProductInfoHover}}/g, itemProductInfoHover);
            } else {
                html = html.replace(/{{itemProductInfoHover}}/g, '');
                html = html.replace(/{{itemReviews}}/g, '');
            }
            if (!boostPFSConfig.custom.enable_quickshop) {
                html = html.replace(/{{itemQuickShop}}/g, '');
            }
        }
        return html;
    }
    
    function buildPrice(data) {
    
        var html = '';
        var onSale = data.compare_at_price_max > data.price_min;
        var soldOut = !data.available;
        var priceVaries = data.price_max != data.price_min;
        var priceMin = data.price_min;
        html += '<span class="product-thumbnail__price price ' + (onSale ? 'sale' : '') + '"> ';
    
        if (!soldOut) {
            if (priceMin !== 999.99 || priceMin !== 99999.00 || priceMin !== 49999.50) {
                if (data.price_min > 0) {
                    if (priceVaries) {
                        html += '<small><em>' + boostPFSConfig.label.from + '</em></small> ';
                    }
                    html += '<span class="money">' + Utils.formatMoney(data.price_min) + '</span> ';
                } else {
                    html += boostPFSConfig.custom.free_price_text;
                }
                if (onSale) {
                    html += '<span class="product-thumbnail__was-price was-price">' +
                        '<span class="money">' + Utils.formatMoney(data.compare_at_price_max) + '</span>' +
                        '</span>';
                }
            } else {
                html += '<span class="product__quote_only">Request Quote</span>';
            }
        } else {
            html += '<span class="product-thumbnail__sold-out ">Request Quote</span>'
        }
    
        return html;
    }
    
    function buildSwatch(data) {
        var html = '';
        var values = [];
        var swatchItems = [];
        if (boostPFSConfig.custom.collection_swatches) {
            data.variants.forEach(function(variant) {
                var colorValue = '';
                var optionValue = '';
                variant.merged_options.forEach(function(option) {
                    var key = option.split(':')[0];
                    var value = option.split(':')[1];
                    if ((key.toLowerCase().indexOf('color') != -1 || key.toLowerCase().indexOf('colour') != -1) && values.indexOf(value.toLowerCase()) == -1) {
                        values.push(value.toLowerCase());
                        colorValue = value;
                        optionValue = key;
                    }
                });
                if (colorValue) {
                    var swatchItem = '<a href="{{variantUrl}}" class="swatch swatch__style--{{swatchShape}}" data-swatch-name="meta-{{slugifyOptionValue}}_{{slugifyColorValue}}">' +
                        '<span data-image="{{variantImage}}" style="background-color: {{colorBackground}}; background-size: auto; background-repeat: no-repeat; background-position: center center;">' +
                        '<img class="swatch__image" src="{{colorImage}}" onerror="this.className += \' swatch__image--empty\'">' +
                        '</span>' +
                        '</a>';
    
                    swatchItem = swatchItem.replace(/{{swatchShape}}/g, boostPFSConfig.custom.collection_swatches_shape);
                    swatchItem = swatchItem.replace(/{{colorBackground}}/g, Utils.slugify(colorValue).split('-').pop());
                    swatchItem = swatchItem.replace(/{{slugifyOptionValue}}/g, Utils.slugify(optionValue).replace('-', '_'));
                    swatchItem = swatchItem.replace(/{{slugifyColorValue}}/g, Utils.slugify(colorValue).replace('-', '_'));
                    swatchItem = swatchItem.replace(/{{variantUrl}}/g, Utils.buildProductItemUrl(data) + '?variant=' + variant.id);
    
                    var colorImage = boostPFSAppConfig.general.file_url.split('?')[0] + Utils.slugify(colorValue) + '_50x.png';
                    swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);
    
                    var variantImage = '';
                    var noImageClass = '';
                    if (variant.image) {
                        switch (boostPFSConfig.custom.products_per_row) {
                            case 2:
                                variantImage = Utils.optimizeImage(variant.image, '600x');
                                break;
                            case 3:
                                variantImage = Utils.optimizeImage(variant.image, '500x');
                                break;
                            default:
                                variantImage = Utils.optimizeImage(variant.image, '400x');
                                break;
                        }
                    }
                    swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
                    swatchItems.push(swatchItem);
                }
            })
        }
        if (swatchItems.length > 0) {
            html = '<div class="thumbnail-swatch is-justify-' + boostPFSConfig.custom.thumbnail_text_alignment + ' is-flex-wrap">' +
                swatchItems.join(' ') +
                '</div>';
        }
        return html;
    }
    
    function bgset(image) {
        var bgset = '';
        if (image) {
            var aspect_ratio = image.width / image.height;
    
            if (image.width > 180) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
            if (image.width > 360) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
            if (image.width > 540) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
            if (image.width > 720) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
            if (image.width > 900) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
            if (image.width > 1080) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
            if (image.width > 1296) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
            if (image.width > 1512) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
            if (image.width > 1728) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
            if (image.width > 1950) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
            if (image.width > 2100) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
            if (image.width > 2260) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
            if (image.width > 2450) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
            if (image.width > 2700) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
            if (image.width > 3000) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
            if (image.width > 3350) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
            if (image.width > 3750) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
            if (image.width > 4100) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
            bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
        }
        return bgset;
    }
    
    // Build Pagination
    ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
        if (!totalProduct) totalProduct = this.totalProduct
    
        // Get page info
        var currentPage = parseInt(Globals.queryParams.page);
        var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    
        if (totalPage > 1) {
            var paginationHtml = boostPFSTemplate.paginateHtml;
            // Build Previous
            var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
            // Build Next
            var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);
            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }
            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
            return paginationHtml;
        }
    
        return '';
    };
    
    // Build Sorting
    ProductSorting.prototype.compileTemplate = function() {
        if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
            var sortingArr = Utils.getSortingList();
            if (sortingArr) {
                // Build content
                var sortingItemsHtml = '';
                for (var k in sortingArr) {
                    sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
                }
                var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
                return html;
            }
        }
        return '';
    };
    ProductLimit.prototype.compileTemplate = function() {
        var html = '';
        var numberList = Settings.getSettingValue('general.showLimitList');
        if (numberList != '') {
            // Build content
            var showLimitItemsHtml = '';
            var arr = numberList.split(',');
            /*Limit Custom*/
            var curr = Globals.queryParams.page * Globals.queryParams.limit;
            showLimitItemsHtml += '<option value="' + curr + '" selected disabled hidden>' + curr + '</option>';
            /*Limit Custom*/
            for (var k = 0; k < arr.length; k++) {
                showLimitItemsHtml += '<option value="' + arr[k] + '">' + arr[k] + ' </option>';
            }
            html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
        }
        return html;
    };
    
    /*Limit Custom*/
    ProductLimit.prototype.render = function() {
        jQ(Selector.topShowLimit).html(this.compileTemplate());
        var $topLimitSelect = jQ(Selector.topShowLimit + ' select');
        if ($topLimitSelect.length) {
            var curr = Globals.queryParams.page * Globals.queryParams.limit;
            $topLimitSelect.val(Utils.stripHtml(curr));
        }
    }
    /*Limit Custom*/
    
    FilterOptionItemMultiLevelCollections.prototype.afterRender = function() {
        if (this.isSelected) this.$itemElement.addClass('boost-pfs-open');
    }
    
    // Add additional feature for product list, used commonly in customizing product list
    ProductList.prototype.afterRender = function(data, eventType) {
        if (!data) data = this.data;
        if (!eventType) eventType = this.eventType;
        this.buildExtrasProductListByAjax(data, 'boost-pfs-integration', function(results) {
            results.forEach(function(result) {
                var element = '';
                element = jQ('[data-id="' + result.id + '"]');
                if (element.find('.boost-cart').length == 0) {
                    element.find('.boost-pfs-cart-btn').append(result.quickcart.trim());
                }
            });
            if (jQ('.boost-pfs-filter-products .rfq-btn').length > 0) {
                GRFQApp.init(jQuery);
            } else {
                $('.cart-btn').click(function() {
                    var ID = $(this).data('variant-id');
                    var quantity = $(this).siblings('input').val();
                    var url = $(this).data('url');
                    addItemToCart(ID, url, quantity); // paste your id product number
                });
            }
        });
    };
    
    // Build additional elements
    FilterResult.prototype.afterRender = function(data, eventType) {
        if (!data) data = this.data;
        if (!eventType) eventType = this.eventType;
    
        if (!Utils.isMobile()) {
            jQ('body').addClass('boost-pfs-filter-tree-open-body')
        }
        var pageLimit = 1
        if (Globals.queryParams.page > 1) {
            pageLimit = (Globals.queryParams.page - 1) * Globals.queryParams.limit + 1
        }
        jQ('.pfs-limit-custom').html('Showing ' + pageLimit + ' - ')
        jQ('.pfs-total-product').html(data.total_product)
        if (data.total_product < Globals.queryParams.page * Globals.queryParams.limit) {
            jQ('.boost-pfs-filter-filter-dropdown-custom option[selected]').html(data.total_product)
        }
    };
    
    function buildTheme() {
        if (window.SPR) {
            SPR.initDomEls();
            SPR.loadBadges();
        }
        Shopify.PaymentButton.init();
    }
    
    function addItemToCart(variant_id, url, qty) {
        data = {
            "id": variant_id,
            "quantity": qty
        }
        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function() {
                // document.dispatchEvent(new CustomEvent('theme:loading:start'));
                // document.dispatchEvent(new CustomEvent('theme:loading:end'));
                // document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                //     bubbles: true
                // }));
                // document.dispatchEvent(new CustomEvent('product:added', {
                //     bubbles: true,
                //     detail: {
                //         variant: variant_id,
                //         quantity: 1
                //     }
                // }));
                // $('.Header__Icon[data-action="open-drawer"]').trigger('click');
                Shopify.theme.jsAjaxCart.updateView();
                Shopify.theme.jsAjaxCart.showDrawer();
            },
            error: function(jqXHR, textStatus, errorThrown) {
                // Check status code
                if (jqXHR.status === 422) {
                    // display error wherever you want to  
                    console.log(jqXHR.responseText);
                }
            }
        });
    }
})();


// // Only send Weglot request if the current language is different from English
// function isWeglotActive() {
//     if (!window.Weglot || !window.Weglot.initialized) {
//       	return false;
//     } else {
//     	var currentLang = Weglot.getCurrentLang();
// 	// Change 'en' to suitable with original language of the store
//     	return currentLang !== 'en';
//     }
// }
    
// FilterApi.beforeCallAsync = function(callFilterApi) {
//     // Then use it in our API
//     if (Utils.isSearchPage() && window.Weglot && window.Weglot.initialized && isWeglotActive()) {
//           Weglot.search(Utils.getSearchTerm(), function(englishTerm) {
//               	Globals.queryParams['q'] = englishTerm;
//               	callFilterApi();
//           });
//     } else {
//           callFilterApi();
//     }
// }